import * as React from 'react'

interface Props {
  timeout?: number
  interval?: number
  disabled?: boolean
  children?: React.ReactNode
  onLongPress?: () => void
  onPress?: () => void
}

interface State {
  shouldShortPress: boolean
  timeout: number
}

export default class LongPressComponent extends React.Component<Props, State> {
  static defaultProps = { timeout: 500, interval: 100  }
  state: State = { shouldShortPress: true, timeout: 0 }

  componentWillUnmount () {
    clearTimeout(this.state.timeout)
  }

  private longPressed () {
    const { interval, onLongPress } = this.props
    this.setState({ timeout: window.setTimeout(this.longPressed.bind(this), interval), shouldShortPress: false })
    if (onLongPress) onLongPress()
  }

  private onTouchStart () {
    this.setState({ shouldShortPress: true, timeout: window.setTimeout(this.longPressed.bind(this), this.props.timeout) })
  }

  private onTouchEnd () {
    const { state: { timeout, shouldShortPress }, props: { onPress } } = this
    clearTimeout(timeout)
    if (onPress && shouldShortPress) onPress()
  }

  private onTouchCancel () {
    clearTimeout(this.state.timeout)
  }

  render () {
    const children = this.props.children as any
    if (this.props.disabled) return children

    const props = {
      onContextMenu: (e: any) => e.preventDefault(),
      onTouchStart: this.onTouchStart.bind(this),
      onTouchEnd: this.onTouchEnd.bind(this),
      onTouchCancel: this.onTouchCancel.bind(this), 
      onMouseDown: this.onTouchStart.bind(this),
      onMouseUp: this.onTouchEnd.bind(this),
      onMouseLeave: this.onTouchCancel.bind(this),
      style: {
        ...children.props.style,
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none'
      }
    }

    return React.cloneElement(children, { ...children.props, ...props })
  }
}
